/** @format */

import React from "react"
import { Circle1, Circle2, Circle3, LoadingCircle } from "./DonutChart.styled"
import { DonutChartProps } from "./DonutsChart.types"

const SPACE_percent = 1.0 / 100.0
const MINIMAL_percent = 2.0 / 100.0 // must be at least 2 *SPACE_percent
const RADIUS = 90


/**
 * Donut chart (atom)
 *
 * @param props
 * @returns React Component
 */
const DonutChart = ({values, isLoading}:DonutChartProps) =>{
  const [val1, val2, val3] = [...(values ? values.map(v => (v === undefined ? 0 : v)) : []), 0, 0, 1];


  const percents = [ val1 / (val1+val2+val3),
                      val2 / (val1+val2+val3),
                      val3 / (val1+val2+val3)];

  const percentTooSmall = percents.filter(p => p > 0 && p < MINIMAL_percent);
  const nbpercentsTooSmall = percentTooSmall.length;
  const nbpercentsOk = percents.filter(p => p > MINIMAL_percent * 2).length;
  const valuesToNormalize = percentTooSmall.reduce((previousValue, current) => {
    if(current>0 && current<MINIMAL_percent){
      return previousValue + MINIMAL_percent-current;
    }
    return previousValue;
  },0);

  const normalizedPercents = percents.map(p => {
    if ((nbpercentsTooSmall===0) || (p ===0))
        return p;
    if (p < MINIMAL_percent) return MINIMAL_percent;
    if (p <= 2 * MINIMAL_percent) return p;

    return p-valuesToNormalize/nbpercentsOk
  });

  const [percent1, percent2, percent3] = normalizedPercents;
  const fullSize = Math.PI * 2 * RADIUS;
  const arcsize1 = fullSize * percent1;
  const arcsize2 = fullSize * percent2;
  const arcsize3 = fullSize * percent3;

  const offset = fullSize/3;

  let space = 0;
  if (percent1 !== 1 && percent2 !== 1 && percent3 !== 1){
    space = SPACE_percent * fullSize;
  }

  const arcsizeWithSpace1 = arcsize1> space ? arcsize1 - space: arcsize1;
  const arcsizeWithSpace2 = arcsize2> space ? arcsize2 - space: arcsize2;
  const arcsizeWithSpace3 = arcsize3> space ? arcsize3 - space: arcsize3;
  const strokeDasharray1 = `${arcsizeWithSpace1}px ${fullSize - arcsizeWithSpace1}px`;
  const strokeDasharray2 = `${arcsizeWithSpace2}px ${fullSize - arcsizeWithSpace2}px`;
  const strokeDasharray3 = `${arcsizeWithSpace3}px ${fullSize - arcsizeWithSpace3}px`;

  return (<svg width="240px" height="240px" viewBox="0 0 240 240" data-testid="donut-chart" >
      {isLoading ?
        <LoadingCircle cx="120" cy="120" r={RADIUS}/>:
        <>
          <Circle1 cx="120" cy="120" r={RADIUS} data-percent={percents[0]} data-normalized-percent={normalizedPercents[0]} strokeDasharray={strokeDasharray1} strokeDashoffset={offset - space /2.0} ></Circle1>
          <Circle2 cx="120" cy="120" r={RADIUS} data-percent={percents[1]} data-normalized-percent={normalizedPercents[1]} strokeDasharray={strokeDasharray2} strokeDashoffset={fullSize - arcsize1 + offset - space/2.0 } ></Circle2>
          <Circle3 cx="120" cy="120" r={RADIUS} data-percent={percents[2]} data-normalized-percent={normalizedPercents[2]} strokeDasharray={strokeDasharray3} strokeDashoffset={fullSize - (arcsize2 + arcsize1) + offset - space/2.0}></Circle3>
        </>
      }
    </svg>)
}

export default DonutChart;